module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content color-1-100"
  }, [(_vm.formStatus.success) ? [_vm._v("\n              Login\n            ")] : [_vm._v("\n              Reset password\n            ")]], 2)]), _vm._v(" "), (!_vm.formStatus.success) ? _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          Please enter below the new password for your Clear Assured account.\n          It must contain at least 9 characters that include capital letters, lower case letters and numbers.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formStatus.success) ? _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus,
      'has-error': _vm.loginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.email),
      expression: "loginForm.email"
    }],
    class: [{
      'border-1-50': _vm.loginForm.email !== '' || _vm.loginForm.emailFocus
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "data-vv-name": "Email"
    },
    domProps: {
      "value": (_vm.loginForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus,
      'has-error': _vm.loginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.loginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginForm.password) ? _vm._i(_vm.loginForm.password, null) > -1 : (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.loginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.loginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginForm.password, null)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.loginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    class: [{
      'border-1-50': _vm.loginForm.password !== '' || _vm.loginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "Password",
      "type": _vm.loginForm.passwordType
    },
    domProps: {
      "value": (_vm.loginForm.password)
    },
    on: {
      "focus": function($event) {
        _vm.loginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.loginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.loginForm.loginInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate()
      }
    }
  }, [_vm._v("Login")])])]) : _vm._e(), _vm._v(" "), (!_vm.formStatus.success) ? _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.first !== '' || _vm.passwordFocus,
      'has-error': this.errors.has('New password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-reset-password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('password')
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.first) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    ref: "password",
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "New password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('New password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('New password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.second !== '' || _vm.retypePasswordFocus,
      'has-error': this.errors.has('Retype new password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password-retype"
    }
  }, [_vm._v("Retype new password")]), _vm._v(" "), _c('a', {
    staticClass: "landing-page-login-password-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('retypePassword')
      }
    }
  }), _vm._v(" "), ((_vm.retypePasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.second) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.second,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$c)
        }
      }
    }
  }) : ((_vm.retypePasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype new password",
      "type": _vm.retypePasswordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype new password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype new password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-form-error",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(_vm.loginForm.isError) ? [_vm._v("\n              " + _vm._s(_vm.loginForm.loginErrorMessage) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword()
      }
    }
  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account several times? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "form-message",
    class: _vm.formStatus.success ? 'success' : 'error',
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? [_vm._v("\n            Submitting\n          ")] : _vm._e(), _vm._v(" "), (_vm.formStatus.shown && !this.formStatus.submitting) ? [(_vm.formStatus.title !== '') ? _c('h2', [_vm._v(_vm._s(_vm.formStatus.title))]) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v(_vm._s(_vm.formStatus.body))]) : _vm._e()] : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee4f06c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ResetPassword/Reset.vue
// module id = 1041
// module chunks = 0